import { UserType } from '@chegg/one-auth-sdk';
export var View;
(function (View) {
  View["SIGNIN"] = "signin";
  View["SIGNUP"] = "signup";
  View["RESET_PASSWORD"] = "resetPassword";
})(View || (View = {}));
export var PxCaptchaTypes;
(function (PxCaptchaTypes) {
  PxCaptchaTypes["LOGIN"] = "signin";
  PxCaptchaTypes["SIGNUP"] = "signup";
  PxCaptchaTypes["RESET_PASSWORD"] = "resetPassword";
})(PxCaptchaTypes || (PxCaptchaTypes = {}));
export var userTypes = Object.keys(UserType);

/**
 * Payloads
 */

export var initialCredentials = {
  email: {
    changed: false,
    touched: false,
    valid: false,
    value: '',
    focus: false,
    error: '',
    valueChanged: false
  },
  password: {
    changed: false,
    touched: false,
    valid: false,
    value: '',
    focus: false,
    error: '',
    valueChanged: false
  }
};
export var initialSso = {
  email: '',
  error: '',
  authProvider: '',
  authProviderToken: ''
};